var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{style:('padding: ' + _vm.padding + '; color: '+ _vm.color),attrs:{"src":_vm.appDir + 'img/icon/' + _vm.icon + '.' + _vm.extension,"width":_vm.width}})])
}
var staticRenderFns = []

export { render, staticRenderFns }